import { render, staticRenderFns } from "./The404.vue?vue&type=template&id=6b360f24&"
import script from "./The404.vue?vue&type=script&lang=js&"
export * from "./The404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports